import { render, staticRenderFns } from "./MultiCollectionInput.vue?vue&type=template&id=6d774c19&"
import script from "./MultiCollectionInput.vue?vue&type=script&lang=js&"
export * from "./MultiCollectionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d774c19')) {
      api.createRecord('6d774c19', component.options)
    } else {
      api.reload('6d774c19', component.options)
    }
    module.hot.accept("./MultiCollectionInput.vue?vue&type=template&id=6d774c19&", function () {
      api.rerender('6d774c19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/inputs/MultiCollectionInput.vue"
export default component.exports